import type { MutationTree } from "vuex";
import type {
  DataExplorerState,
  Graph,
  GraphVariableOrFormula,
  Dashboard,
} from "@/types";

export const LOAD_DASHBOARDS = "LOAD_DASHBOARDS";
export const LOAD_DASHBOARDS_SUCCESS = "LOAD_DASHBOARDS_SUCCESS";
export const LOAD_DASHBOARDS_FAILURE = "LOAD_DASHBOARDS_FAILURE";

export const LOAD_DASHBOARD = "LOAD_DASHBOARD";
export const LOAD_DASHBOARD_SUCCESS = "LOAD_DASHBOARD_SUCCESS";
export const LOAD_DASHBOARD_FAILURE = "LOAD_DASHBOARD_FAILURE";

export const LOAD_DASHBOARD_REPORT = "LOAD_DASHBOARD_REPORT";
export const LOAD_DASHBOARD_REPORT_SUCCESS = "LOAD_DASHBOARD_REPORT_SUCCESS";
export const LOAD_DASHBOARD_REPORT_FAILURE = "LOAD_DASHBOARD_REPORT_FAILURE";

export const UPDATE_DASHBOARDS = "UPDATE_DASHBOARDS";

export const ADD_DASHBOARD = "ADD_DASHBOARD";
export const ADD_DASHBOARD_SUCCESS = "ADD_DASHBOARD_SUCCESS";
export const ADD_DASHBOARD_FAILURE = "ADD_DASHBOARD_FAILURE";

export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const UPDATE_DASHBOARD_SUCCESS = "UPDATE_DASHBOARD_SUCCESS";
export const UPDATE_DASHBOARD_FAILURE = "UPDATE_DASHBOARD_FAILURE";

export const DELETE_DASHBOARD = "DELETE_DASHBOARD";
export const DELETE_DASHBOARD_SUCCESS = "DELETE_DASHBOARD_SUCCESS";
export const DELETE_DASHBOARD_FAILURE = "DELETE_DASHBOARD_FAILURE";

export const LOAD_GRAPH = "LOAD_GRAPH";
export const LOAD_GRAPH_SUCCESS = "LOAD_GRAPH_SUCCESS";
export const LOAD_GRAPH_FAILURE = "LOAD_GRAPH_FAILURE";

export const ADD_GRAPH = "ADD_GRAPH";
export const ADD_GRAPH_SUCCESS = "ADD_GRAPH_SUCCESS";
export const ADD_GRAPH_FAILURE = "ADD_GRAPH_FAILURE";

export const ADD_REPORT_GRAPH = "ADD_REPORT_GRAPH";
export const ADD_REPORT_GRAPH_SUCCESS = "ADD_REPORT_GRAPH_SUCCESS";
export const ADD_REPORT_GRAPH_FAILURE = "ADD_REPORT_GRAPH_FAILURE";

export const UPDATE_GRAPH = "UPDATE_GRAPH";
export const UPDATE_GRAPH_SUCCESS = "UPDATE_GRAPH_SUCCESS";
export const UPDATE_GRAPH_FAILURE = "UPDATE_GRAPH_FAILURE";

export const UPDATE_GRAPH_DATA = "UPDATE_GRAPH_DATA";
export const UPDATE_GRAPH_DATA_SUCCESS = "UPDATE_GRAPH_DATA_SUCCESS";
export const UPDATE_GRAPH_DATA_FAILURE = "UPDATE_GRAPH_DATA_FAILURE";

export const UPDATE_GRAPH_IN_DASH = "UPDATE_GRAPH_IN_DASH";
export const UPDATE_GRAPH_IN_DASH_SUCCESS = "UPDATE_GRAPH_IN_DASH_SUCCESS";
export const UPDATE_GRAPH_IN_DASH_FAILURE = "UPDATE_GRAPH_IN_DASH_FAILURE";

export const mutations: MutationTree<DataExplorerState> = {
  // LOAD_DASHBOARDS
  [LOAD_DASHBOARDS](state: DataExplorerState) {
    state.dashboards = { ...state.dashboards, loading: true, error: null };
  },
  [LOAD_DASHBOARDS_SUCCESS](state: DataExplorerState, dashs: Dashboard[]) {
    state.dashboards = { data: dashs, loading: false, error: null };
  },
  [LOAD_DASHBOARDS_FAILURE](state: DataExplorerState, error: string) {
    state.dashboards = { ...state.dashboards, loading: false, error: error };
  },

  [UPDATE_DASHBOARDS](state: DataExplorerState, dash: Dashboard) {
    const oldDashIndex: number = state.dashboards.data.findIndex(
      (dashboard: Dashboard) => dashboard.id === dash.id,
    );
    if (oldDashIndex !== -1) {
      state.dashboards.data[oldDashIndex] = {
        ...dash,
      };
    }
  },
  // LOAD_DASHBOARDimage.png
  [LOAD_DASHBOARD](state: DataExplorerState) {
    state.dashboard = { ...state.dashboard, loading: true, error: null };
  },
  [LOAD_DASHBOARD_SUCCESS](state: DataExplorerState, dash: Dashboard) {
    state.dashboard = { data: dash, loading: false, error: null };
  },
  [LOAD_DASHBOARD_FAILURE](state: DataExplorerState, error: string) {
    state.dashboard = { ...state.dashboard, loading: false, error: error };
  },

  // LOAD_DASHBOARD_REPORT
  [LOAD_DASHBOARD_REPORT](state: DataExplorerState) {
    state.dashboardReport = {
      ...state.dashboardReport,
      loading: true,
      error: null,
    };
  },
  [LOAD_DASHBOARD_REPORT_SUCCESS](state: DataExplorerState, dash: Dashboard) {
    state.dashboardReport = { data: dash, loading: false, error: null };
  },
  [LOAD_DASHBOARD_REPORT_FAILURE](state: DataExplorerState, error: string) {
    state.dashboardReport = {
      ...state.dashboardReport,
      loading: false,
      error: error,
    };
  },

  // ADD_DASHBOARD
  [ADD_DASHBOARD](state: DataExplorerState) {
    state.dashboards = { ...state.dashboards, loading: true, error: null };
  },
  [ADD_DASHBOARD_SUCCESS](state: DataExplorerState, dash: Dashboard) {
    state.dashboards = {
      data: [...state.dashboards.data, ...[dash]],
      loading: false,
      error: null,
    };
  },
  [ADD_DASHBOARD_FAILURE](state: DataExplorerState, error: string) {
    state.dashboards = { ...state.dashboards, loading: false, error: error };
  },

  // UPDATE_DASHBOARD
  [UPDATE_DASHBOARD](state: DataExplorerState) {
    state.dashboard = { ...state.dashboard, loading: true, error: null };
  },
  [UPDATE_DASHBOARD_SUCCESS](state: DataExplorerState, dash: Dashboard) {
    state.dashboard = { data: dash, loading: false, error: null };
  },

  [UPDATE_DASHBOARD_FAILURE](state: DataExplorerState, error: string) {
    state.dashboard = { ...state.dashboard, loading: false, error: error };
  },

  // DELETE_DASH
  [DELETE_DASHBOARD](state: DataExplorerState) {
    state.dashboards = { ...state.dashboards, loading: true, error: null };
  },
  [DELETE_DASHBOARD_SUCCESS](state: DataExplorerState, dashId: string) {
    state.dashboards.loading = false;
    state.dashboards.error = null;
    state.dashboards.data = state.dashboards.data.filter(
      (dash: Dashboard) => dash.id !== dashId,
    );
  },
  [DELETE_DASHBOARD_FAILURE](state: DataExplorerState, error: string) {
    state.dashboards = { ...state.dashboards, loading: false, error: error };
  },

  // ADD_GRAPH
  [ADD_GRAPH](state: DataExplorerState) {
    state.graph = { ...state.graph, loading: true, error: null };
  },
  [ADD_GRAPH_SUCCESS](state: DataExplorerState) {
    state.graph = { ...state.graph, loading: false, error: null };
  },
  [ADD_GRAPH_FAILURE](state: DataExplorerState, error: string) {
    state.graph = { ...state.graph, loading: false, error: error };
  },

  // ADD_REPORT_GRAPH
  [ADD_REPORT_GRAPH](state: DataExplorerState) {
    state.reportGraphs = { ...state.reportGraphs, loading: true, error: null };
  },
  [ADD_REPORT_GRAPH_SUCCESS](state: DataExplorerState, graph: any) {
    const indexGraphInData = state.reportGraphs.data.findIndex(
      (dataGraph: any) => dataGraph.id === graph.id,
    );
    if (indexGraphInData !== -1) {
      state.reportGraphs.data[indexGraphInData] = {
        ...graph,
        graphVariables: graph.variables,
      };
    } else {
      state.reportGraphs.data = [
        ...state.reportGraphs.data,
        { ...graph, graphVariables: graph.variables },
      ];
    }

    state.reportGraphs.data = [...state.reportGraphs.data];
    state.reportGraphs.loading = false;
    state.reportGraphs.error = null;
  },
  [ADD_REPORT_GRAPH_FAILURE](state: DataExplorerState, error: string) {
    state.reportGraphs = {
      ...state.reportGraphs,
      loading: false,
      error: error,
    };
  },

  // LOAD_GRAPH
  [LOAD_GRAPH](state: DataExplorerState) {
    state.graph = { ...state.graph, loading: true, error: null };
  },
  [LOAD_GRAPH_SUCCESS](state: DataExplorerState, graph: Graph) {
    state.graph = {
      data: graph,
      loading: false,
      error: null,
    };
  },
  [LOAD_GRAPH_FAILURE](state: DataExplorerState, error: string) {
    state.graph = { ...state.graph, loading: false, error: error };
  },

  // UPDATE_GRAPH
  [UPDATE_GRAPH](state: DataExplorerState) {
    state.graph = { ...state.graph, loading: true, error: null };
  },
  [UPDATE_GRAPH_SUCCESS](state: DataExplorerState, graph: Graph) {
    state.graph = {
      data: graph,
      loading: false,
      error: null,
    };
  },
  [UPDATE_GRAPH_FAILURE](state: DataExplorerState, error: string) {
    state.graph = { ...state.graph, loading: false, error: error };
  },

  //UPDATE_GRAPH_DATA
  [UPDATE_GRAPH_DATA](state: DataExplorerState) {
    state.graph = { ...state.graph, loading: false, error: null };
  },
  [UPDATE_GRAPH_DATA_SUCCESS](
    state: DataExplorerState,
    variable: GraphVariableOrFormula,
  ) {
    const variableIndex = state.graph.data.graphVariables.findIndex(
      (variableGraph: GraphVariableOrFormula) =>
        variableGraph.object.id === variable.object.id &&
        variableGraph.aggregation.id === variable.aggregation.id,
    );

    if (variableIndex !== -1) {
      state.graph.data.graphVariables[variableIndex] = {
        ...state.graph.data.graphVariables[variableIndex],
        data: variable.data,
      } as GraphVariableOrFormula;

      state.graph.data = {
        ...state.graph.data,
        sampling: variable.preferredSampling,
        samplingUnit: variable.preferredSamplingUnit,
      } as Graph;
    } else {
      state.graph.data = {
        ...state.graph.data,
        sampling: variable.preferredSampling,
        samplingUnit: variable.preferredSamplingUnit,
        variables: [
          ...state.graph.data.graphVariables,
          ...[{ ...variable, sampling: undefined, samplingUnit: undefined }],
        ] as GraphVariableOrFormula[],
      } as Graph;
    }
  },
  [UPDATE_GRAPH_DATA_FAILURE](state: DataExplorerState, error: string) {
    state.graph = { ...state.graph, loading: false, error: error };
  },

  // UPDATE_GRAPH_IN_DASH
  [UPDATE_GRAPH_IN_DASH](state: DataExplorerState) {
    state.dashboard = { ...state.dashboard, loading: true, error: null };
  },
  [UPDATE_GRAPH_IN_DASH_SUCCESS](state: DataExplorerState, graph: Graph) {
    state.dashboard.loading = false;
    state.dashboard.error = null;

    const graphInDashIndex: number = state.dashboard.data.graphs.findIndex(
      (graphe: Graph) => graphe.id === graph.id,
    );

    state.dashboard.data.graphs[graphInDashIndex] = {
      ...graph,
      dashboardId: undefined,
    } as unknown as Graph;
  },
  [UPDATE_GRAPH_IN_DASH_FAILURE](state: DataExplorerState, error: string) {
    state.dashboard = { ...state.dashboard, loading: false, error: error };
  },
};
